/**
 * @deprecated Use `@/features/profile/api/profile.api` instead.
 * This file provides backward-compatible wrappers during the SPA migration.
 *
 * Functions that previously used verifySession() to get userId now decode
 * the in-memory access token to extract it.
 */

import { getAccessToken } from "@/shared/lib/auth-fetch"
import * as ProfileApi from "../api/profile.api"
import type { UpdateAboutMeForm } from "../schemas/profile-form.schema"
import type { ProfileLocationForm } from "../schemas/profile-location-form.schema"
import type { StmInformationFormSchema } from "../schemas/stm-information-form.schema"
import type { ProfileBaseInformationFormType } from "../schemas/profile-base-information-form.schema"

// Re-export unchanged functions  
export { getVolunteerProfile, PROFILE_QUERY_KEYS } from "../api/profile.api"

function getUserIdFromToken(): number {
  const token = getAccessToken()
  if (!token) throw new Error("No session found")
  try {
    const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")))
    return parseInt(payload.sub)
  } catch {
    throw new Error("No session found")
  }
}

export async function getProfile() {
  const userId = getUserIdFromToken()
  return ProfileApi.getProfile(userId)
}

export async function updateProfile(data: UpdateAboutMeForm) {
  const userId = getUserIdFromToken()
  return ProfileApi.updateProfile(userId, data)
}

export async function createProfileLocation(data: ProfileLocationForm) {
  const userId = getUserIdFromToken()
  return ProfileApi.createProfileLocation(userId, data)
}

export async function createProfileStm(data: StmInformationFormSchema) {
  const userId = getUserIdFromToken()
  return ProfileApi.createProfileStm(userId, data)
}

export async function createProfileBaseInformation(data: ProfileBaseInformationFormType) {
  const userId = getUserIdFromToken()
  return ProfileApi.createProfileBaseInformation(userId, data)
}

export async function uploadProfilePicture(_userId: number, file: any) {
  const userId = getUserIdFromToken()
  return ProfileApi.uploadProfilePicture(userId, file)
}

export async function updateSelectedRegion(selectedRegionId: string | number) {
  const userId = getUserIdFromToken()
  return ProfileApi.updateSelectedRegion(userId, selectedRegionId)
}

export async function updateProfileWithGoogleSignupInfo(
  userId: number,
  data: { fullname?: string; phone?: string },
) {
  return ProfileApi.updateProfileWithGoogleSignupInfo(userId, data)
}

export async function deleteProfilePicture(userId: number) {
  return ProfileApi.deleteProfilePicture(userId)
}

export async function deleteLocationImage(userId: number, imageUrl: string) {
  return ProfileApi.deleteLocationImage(userId, imageUrl)
}

export async function deleteBaseImage(userId: number, imageUrl: string) {
  return ProfileApi.deleteBaseImage(userId, imageUrl)
}